// Admin panel API çağrıları — services/api.js'teki hostname bazlı seçim deseniyle aynı.
const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.endsWith('.localhost');
const MEMBER_API = isLocal ? 'http://localhost:5290' : 'https://member.api.hirethink.ai';

function getAdminToken() {
  return localStorage.getItem('admin_token');
}

async function postJson(path, body) {
  const res = await fetch(`${MEMBER_API}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  let json = null;
  try {
    json = await res.json();
  } catch {
    json = null;
  }

  return { ok: res.ok, httpStatus: res.status, ...json };
}

// admin.hirethink.ai ile paylaşılan aynı login — ayrı bir admin kullanıcı/şifre
// sistemi yok. Yetki kontrolü backend'de: sadece izinli hesaplar admin API'lerinden
// veri alabilir, diğerleri 403 görür. FE email whitelist'i tutmaz.
// Yanıt iki şekilde gelebilir: data.token (2FA yok/atlandı, giriş tamam) veya
// data.isTwoFactor:true + data.tokenId (SMS koduyla CodeVerify'a geçilmeli).
// Bu ayrım yalnızca response'tan okunur, email'e göre dallanma YAPILMAZ.
export async function adminLogin(email, password) {
  return postJson('/api/Auth/Login', { email, password });
}

// SMS ile gelen 6 haneli kodu doğrular. Kod yanlış/süresi dolmuşsa BE 404 döner.
export async function adminVerifyCode(tokenId, code) {
  return postJson('/api/Auth/CodeVerify', { tokenId, code });
}

// Diğer admin uçları için: 401 (oturum geçersiz) ve 403 (yetkisi yok) ayrımını
// koruyarak login ekranına geri atar — 'admin-logout' event'i reason taşır.
export async function adminAuthFetch(url, options = {}) {
  const token = getAdminToken();
  const res = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });

  if ((res.status === 401 || res.status === 403) && token) {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_refresh_token');
    localStorage.removeItem('admin_user');
    window.dispatchEvent(
      new CustomEvent('admin-logout', {
        detail: { reason: res.status === 403 ? 'forbidden' : 'unauthorized' },
      })
    );
  }

  return res;
}
